import { AppBar, Divider } from "@material-ui/core";
import clsx from "clsx";
import { Header } from "components/Header/Header";
import HeaderMenu from "components/HeaderMenu/HeaderMenu";
import LoadingIndicator from "components/LoadingIndicator/LoadingIndicator";
import Navbar from "components/Navbar/Navbar";
import { observer } from "mobx-react";
import { contentWrapperStyles } from "pages/ContentWrapper/ContentWrapperStyles";
import React, { useEffect } from "react";
import { Route, Switch, useHistory, withRouter } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import { globalRoutes } from "routes/Routes";
import { useStore } from "store/StoreConfigs";

function ContentWrapper() {
    const classes = contentWrapperStyles();
    const { commonStore, identityStore } = useStore();
    const history = useHistory();

    useEffect(() => {
        identityStore.loadIdentity();
    }, []);

    if (identityStore.loading || identityStore.userInfo === undefined) {
        return (
            <div className={classes.indicatorContainer}>
                <LoadingIndicator />
            </div>
        );
    }

    console.log("Customer: " + identityStore.currentCustomerId);

    return (
        <div className={classes.root} id="content">
            <AppBar
                position="fixed"
                className={clsx(classes.appBar, {
                    [classes.appBarShift]: commonStore.isNavbarOpen,
                })}
            >
                <Header></Header>
                <Divider></Divider>
                {(commonStore.currentView === "global" ||
                    commonStore.currentView === "lane" ||
                    commonStore.currentView === "route") && (
                    <div
                        className={clsx({
                            [classes.appSecondBarShift]: commonStore.isFilterOpen,
                        })}
                    >
                        <HeaderMenu />
                    </div>
                )}
            </AppBar>
            <Navbar />

            <Switch>
                {globalRoutes.map((route) => (
                    <Route key={route.path} path={route.path} exact={route.exact} component={route.component} />
                ))}
                <Route path="*">{() => history.push("/thor")}</Route>
            </Switch>

            <ToastContainer
                position="bottom-right"
                closeButton={false}
                closeOnClick={false}
                hideProgressBar
                autoClose={false}
                limit={6}
            />
        </div>
    );
}
export default withRouter(observer(ContentWrapper));
